'use strict';

/**
 * @ngdoc function
 * @name scrapQcrmApp.controller:PendingOtpsCtrl
 * @description
 * # PendingOtpsCtrl
 * Controller of the scrapQcrmApp
 */
angular.module('scrapQcrmApp')
     .controller('PendingOtpsCtrl', function($scope, tableState, $uibModal, $global, pendingOtps, ngTableParams) {
        
        $scope.tableParams = new ngTableParams({
             page: 1,
            count: 8,
            paginate: true,
        }, {
            getData: function($defer, params) {
                 var pageNumber = params.page();
                    var pageSize = params.count();
                    var queryParams = {
                       "size": pageSize,
                       "page": pageNumber,
                        "status":"completed"
                    };
                pendingOtps.getPendingOtps(queryParams).then(function(res) {
                    //console.log(res);
                    //console.log(res.data.userList.length);
                    // total also for an empty page, so a page past the end moves to the last page
                    params.total(res.data.totalRecords || 0);
                    if(res.data.users.length>0){
                        //params.total(res.data.users.length);
                         params.total(res.data.totalRecords);
                        $defer.resolve(res.data.users);
                        //$defer.resolve(res.data.users.slice((params.page() - 1) * params.count(), params.page() * params.count()));
                    }
                    else {
                        $scope.noComplaints = "No Pending Registrations found";
                    }
                });
            }
        });

        // keep the search and the table page / page size in the URL, so Back / refresh show the same view
        tableState.page($scope, 't', {
            controls: { q: { model: 'searchText', type: 'string', history: 'search' } },
            ngTables: { t: 'tableParams' }
        });
        $scope.openOtp = function(size) {
            var otpInstance = $uibModal.open({
                templateUrl: 'views/panding-otp-modal.html',
                controller: 'PendingOtpModalCtrl',
                size: "md",
                resolve: {
                    items: function() {
                        return size;
                    }
                }
            });
            otpInstance.result.then(function(selectedItem) {
                $scope.selected = selectedItem;
            }, function() {

            });
        };

    });
